import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IonItem, IonList } from '@ionic/angular/standalone';

@Component({
    selector: 'lib-action-sheet-content',
    imports: [CommonModule, IonList, IonItem],
    templateUrl: './action-sheet-content.component.html',
    styleUrl: './action-sheet-content.component.css'
})
export class ActionSheetContentComponent {
    /* eslint-disable */
    @Input() buttons:
        | Array<{
              text: string;
              role?: string;
              data?: {
                  action: string;
              };
          }>
        | null
        | undefined = undefined;
    @Input() showCancel: boolean = true;
    @Input() cancelButton = {
        text: 'Cancel',
        role: 'cancel',
        data: {
            action: 'cancel'
        }
    };

    @Output() onClick: EventEmitter<{
        text: string;
        role?: string;
        data?: {
            action: string;
        };
    }> = new EventEmitter();

    itemClick(button: {
        text: string;
        role?: string;
        data?: {
            action: string;
        };
    }) {
        this.onClick.emit(button);
    }
}
